module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/leaderboard.png?d1fe1304a0711c6863d0dd57d8854871";